import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as common from '../../../../common'

const DOC = gql`
  query AdminAgentKnowledgeBaseManagement {
    adminAgentKnowledgeBaseManagement {
      agents {
        agentId
        agentName
        dataSources {
          description
          id
          knowledgeBaseId
        }
      }
      sharedDataSource {
        description
        id
        knowledgeBaseId
      }
    }
  }
`

const DATA_SOURCE_TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.object<
    graphql.schema.AdminAgentKnowledgeBaseManagementQuery['adminAgentKnowledgeBaseManagement']['sharedDataSource'],
    ents.core.agent.KnowledgeBase.Management.DataSource
  >({
    description: transformers.PASS_THROUGH,
    id: transformers.PASS_THROUGH,
    knowledgeBaseId: graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      ents.core.agent.KnowledgeBase.assertIsKnowledgeBase,
    ),
  }),
)

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.AdminAgentKnowledgeBaseManagementQuery,
    ents.core.agent.KnowledgeBase.Management,
    'adminAgentKnowledgeBaseManagement'
  >(
    'adminAgentKnowledgeBaseManagement',
    graphql.transformers.OUT.object({
      agents: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            agentId: common.gql.enums.agentId.TRANSFORMER,
            agentName: transformers.PASS_THROUGH,
            dataSources: graphql.transformers.OUT.default(
              graphql.transformers.OUT.list(DATA_SOURCE_TRANSFORMER, {
                onNullish: 'remove',
              }),
              [],
            ),
          }),
          { onNullish: 'remove' },
        ),
        [],
      ),
      sharedDataSource: DATA_SOURCE_TRANSFORMER,
    }),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.AdminAgentKnowledgeBaseManagementQuery,
  ents.core.agent.KnowledgeBase.Management,
  graphql.schema.AdminAgentKnowledgeBaseManagementQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
